import React from 'react';

export class MetricsApiError extends Error {
    constructor(code, description) {
        super(description);
        this.status = code;
        this.description = description;
    }
}

export function downsampledMetricsAlert(message) {
    return (
        <div className="alert alert-warning">
            {message}
        </div>
    );
}



/** WEBPACK FOOTER **
 ** ./src/utils/metricsUtils.js
 **/